import { render, staticRenderFns } from "./CopFreightSearchEditComponent.vue?vue&type=template&id=46d55d1b"
import script from "./CopFreightSearchEditComponent.vue?vue&type=script&lang=js"
export * from "./CopFreightSearchEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CopFreightSearchEditComponent.vue?vue&type=style&index=0&id=46d55d1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports